import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FileSaver from "file-saver";
import Button from "@mui/material/Button";
import axios from "axios";
import Stack from "@mui/material/Stack";
import { useNavigate } from "react-router-dom";
import LoadingButton from "@mui/lab/LoadingButton";
import { useState } from "react";
import FormHelperText from "@mui/material/FormHelperText";

export default function DowloadFiles({ ivnum, name, style }) {
  const navigate = useNavigate();
  const [error, setError] = useState({});
  const [loading, setLoading] = useState({});
  const downloadPdf = async (ivnum) => {
    setLoading((prevState) => ({ ...prevState, [ivnum]: true }));
    try {
      const response = await axios.get(`openInvoices/getFile/${ivnum}`, {
        withCredentials: true,
      });

      let fileContent = response.data["data"];
      const base64Data = `data:application/pdf;base64,${fileContent}`;
      FileSaver.saveAs(base64Data, `${ivnum}.pdf`);
      setError((prevState) => ({
        ...prevState,
        [ivnum]: false,
      }));
    } catch (error) {
      setError((prevState) => ({
        ...prevState,
        [ivnum]: true,
      }));
      if (error.response.status == 403) {
        navigate("/");
      }
    }
    setLoading((prevState) => ({ ...prevState, [ivnum]: false }));
  };

  return (
    <Stack>
      <LoadingButton
        variant={style === "none" ? "" : "outlined"}
        loading={loading[ivnum] || false}
        sx={{ marginBottom: "1rem", marginRight: "0.5rem" }}
        onClick={() => downloadPdf(ivnum)}
        startIcon={<FileDownloadIcon />}
        // color = {error[ivnum] && "error"}
        {...(error[ivnum] && { color: "error" })}
      >
        {error[ivnum] ? "התקבלה שגיאה" : name}
      </LoadingButton>
    </Stack>
  );
}
